
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index2wM0nP0Vh5d_EElvtU5oLcUIjnk4kTF9CxXy7fgBpxwMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/index.vue?macro=true";
import { default as peacockVzm2PdpeycDCuoiUjLvhKhkL_Xco1dOz_FQ0T5UWW6gMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/peacock.vue?macro=true";
import { default as sandbox60eORDkvM98oufsZKc5fIzeATAA1y_452FbbqJJckI6SwMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/sandbox.vue?macro=true";
import { default as index55OfdNSNiBk7CWhWVlWWDL95a60FVPzeBF1S42x_45xaYMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/blog/index.vue?macro=true";
import { default as _91post_93hcLKUBJdfQQ9KEhRtrVEsTtbwc9cAhZXx7GNVtN1zywMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/blog/[post].vue?macro=true";
import { default as indext6JcWF7BSq6pR6qtBueVCCskuwpbRV5fm2AZxP6i9twMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/events/index.vue?macro=true";
import { default as privacytermsZAxMQxf8w1ciWYCZvjC3IV7SJ4BBSOenQvqzO3RP1_45kMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/privacyterms.vue?macro=true";
import { default as indexOzlsRdg1FAoGsUcUsbL2tJdMUaCoK_rQ6aaqwmNRWM0Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/index.vue?macro=true";
import { default as faqU2b4s3hkGPWxnDlaK97LIqL9PRrs8gaoHof_5gUWH3IMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue?macro=true";
import { default as current_45offersajOiUvk_45GGweezJhvpbjikuDO0zqLDvwA0Zqj1Tzym8Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/current-offers.vue?macro=true";
import { default as indexXHC_XY1lAbivhuQrm61YsvZfj3FE4B_XBOEpLcZBOg8Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue?macro=true";
import { default as new_45home_45searchXzztosTbXW5se6BDSxXAiTxCtLf8d6kWMSG0_ZgMoxMMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/new-home-search.vue?macro=true";
import { default as indexdiWcvQ6JohQrvetdeAFWi34k_45TWue_45Q3aK_45jdoLRvYoMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue?macro=true";
import { default as partner_45with_45uszOt88ZdwA0tUBmV9LXt2akwBcWi8I0fKefOoOOT3L0oMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue?macro=true";
import { default as indexLQzwf_45vW20nYjb8sgysOPP2dE1UmD3d30o94T6B2wUgMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue?macro=true";
import { default as land_45acquisition72UacmRvos6uSq1FIRS5FF0SgV9LQkyYMPBBOsQkB3oMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue?macro=true";
import { default as _91_46_46_46slug_930QJUlxQHju29sC97D9rtwFkgdTJJEN0gsQxzKdNRnEwMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue?macro=true";
import { default as our_45teamQVoxnxXrwpqNoc3zrOjaG7jLWbhQK4qaJWbN_45qLEhhsMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue?macro=true";
import { default as our_45neighborhoodskGsG_zAzBwUarH5q2bl2R_45ef_452S8LxVxUO2dEzgbL3kMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue?macro=true";
import { default as _91_46_46_46slug_93NEoeBLU_45nVnHJhKDsK4oCvfeXJ_45agN3gu5QWI7UG7osMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue?macro=true";
import { default as index5b0NTVK24uHPVEwRQJ1jL51NJsuTnBBqye80THVThS8Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue?macro=true";
import { default as knolls_45hoa_45informationr8kaDkoIJB1PeYBizUUbnTQS9r5IeitEmaFmFXg89jcMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue?macro=true";
import { default as brents_45placefBqrMfWC0S5sj3unv9Jv8_5TXzd8_16ceeU_jIsMHW8Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue?macro=true";
import { default as _91_46_46_46slug_93UoPpg3heXhs37ir2vmp6nkn2IgNpaPUstdAML0u5GDMMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue?macro=true";
import { default as rebuilding_45altadena_45casau9RBQz_45y2OKe6LEnC87RxLMRDkR7LY4WVeqqFxdWAMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/rebuilding-altadena-ca.vue?macro=true";
import { default as indexX5yeAVpyCTRNw_nK9EXqwIwFgYJqmXjYF04no_dUvGAMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue?macro=true";
import { default as our_45locationsmlRnon9NUyzu_NTcoH2_45UJ1GJ45Qoe3RRH_45WXREI3EQMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue?macro=true";
import { default as open_45door_45daysVcox2aDtS6w5jtTFHmXgVQAl3HAkSpV0raTUhcbNMaoMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/open-door-days.vue?macro=true";
import { default as fun_45part_45journeyg80h1cBmubLzsPg9RqofKDjl99vSDdSHRzL3uZ3zJUEMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue?macro=true";
import { default as preferred_45lendergFQl_kT_45bsmwbsbLXdCic1lCEd00ioH9woFIemdabYgMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue?macro=true";
import { default as ask_45a_45questionHQTL5otJsWFDlp7j6Z7G_4549jBF_45QpE1FIakHUP6r6_45oMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue?macro=true";
import { default as realtor_45resourcesC3HFWDvE0RlsohUAYpJ0b__45rujHokmckZ83oEX6sOLIMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue?macro=true";
import { default as central_45park_45special_45offeroE5fCiaNLbZuW0SZLbbvCCMZS8yPauN2aL4g9ALmFusMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue?macro=true";
import { default as rebuilding_45altadena_45ca_45mapwvt2Nf_45WAe57au_458hRlijJ3tHOKCc5ElTClxSjKa0lwMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/rebuilding-altadena-ca-map.vue?macro=true";
import { default as sonders_45lifestylektaF3fToIX4xk1XQowkMKPopXjt3d2cYiY_xtBC3mCIMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/sonders-lifestyle.vue?macro=true";
import { default as sonders_45lifestyle_45thank_45youLbkw460qVBfimk9ABH91uo6H9TUa2eCk04w4VG4HJdAMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/sonders-lifestyle-thank-you.vue?macro=true";
import { default as baseline_45new_45home_453k_45payment4XiYQ40gnklAdgtaYn_454nZq6FUz5WZERmE3XZo9TtOgMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/baseline-new-home-3k-payment.vue?macro=true";
import { default as whats_45lifefullness3ci4Z0zHPkITIMjd_hKQ3xrqz3V2K61l0ytU0M8NEhgMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue?macro=true";
import { default as how_45to_45build_45with_45usEQ__WDVTKGQajWm59M0i_45hyes1UmvzOkvWbdZaLXuq4Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/how-to-build-with-us.vue?macro=true";
import { default as indexzBL0XXWKqQ6HtNL6A2Or8Gv9ASZNM7lr7OOeactP0PMMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue?macro=true";
import { default as homeowner_45resourcesVmsLKGsmf_oplwnV8uRL3IxVsjtH2niK7fd7X16_24cMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue?macro=true";
import { default as energy_45green_45practiceshgQdtPeYgRWYNSubrZ0axTKbb9ogyxQ4hb6jL_45ww13sMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue?macro=true";
import { default as career_45opportunitiessGmTNYELiLpU04ZNKJoo1n_wZ5SrCdEsD2Qv3HjXausMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue?macro=true";
import { default as _91testimonial_93uHr8c8GoiOj8uvqOeuc3dGwBdOsYJjYNOgcYZmWhg8UMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue?macro=true";
import { default as indexRF22jxVKL3LFrP0MkLBSRHjqF_eCa1M2b8BCovvkQCYMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue?macro=true";
import { default as easyhouseZUojArlqJIerbM_452Fr57MPwxbfVqApp24VFXz9CYGqoMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue?macro=true";
import { default as experience_45lower_45maintenancev2wTnWmTAS134A53q5HGlu9QX_45eLXKPpBVh7nPqcBrUMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue?macro=true";
import { default as wee_45cottageGt_1U5LIhD8U_45AfAlK1VJ1fc_imxXiCP9qWVRk4bnV0Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue?macro=true";
import { default as homesafe_45colorado_45master_45builderArBleTseALP5UtWI7pDSKOgeoD8q270B8aaOBwCaw30Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue?macro=true";
import { default as limitededitionMZE5dk06O_45ZWsGY6E_MoD4fTBBymEttCfm2W9gfVelUMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue?macro=true";
import { default as indexi2QA1C236HidzxDpK4cYa3_opLm3hmxxiKjzYzs_afcMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue?macro=true";
import { default as index_455HuD2CCQzEPlkTE58yiWmXchzxH5PgZS0QhBlr4No0Meta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue?macro=true";
import { default as indexsd1HTg7TJW3CmHgmBNS_6HR9dHmF_RPF4H8Ja_45GZnLYMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue?macro=true";
import { default as indexkgZoGaGaJyqQLBtXw8E4oUaVrIzCOjPpcJLLGitmptgMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue?macro=true";
import { default as deed_45restricted_45wee_45cottage0_4BOFrPRcJvG_45Ww3SHaGI9zQMEjc95Veo2FW3nklaQMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/deed-restricted-wee-cottage.vue?macro=true";
import { default as component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM } from "/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/index.vue")
  },
  {
    name: "peacock",
    path: "/peacock",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/peacock.vue")
  },
  {
    name: "sandbox",
    path: "/sandbox",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/sandbox.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/blog/index.vue")
  },
  {
    name: "blog-post",
    path: "/blog/:post()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/blog/[post].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/events/index.vue")
  },
  {
    name: "privacyterms",
    path: "/privacyterms",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/privacyterms.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/index.vue")
  },
  {
    name: "contact-us-faq",
    path: "/contact-us/faq",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue")
  },
  {
    name: "current-offers",
    path: "/current-offers",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/current-offers.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue")
  },
  {
    name: "new-home-search",
    path: "/new-home-search",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/new-home-search.vue")
  },
  {
    name: "our-homes",
    path: "/our-homes",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue")
  },
  {
    name: "partner-with-us",
    path: "/partner-with-us",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue")
  },
  {
    name: "land-acquisition",
    path: "/land-acquisition",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue")
  },
  {
    name: "videos-slug",
    path: "/videos/:slug(.*)*",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue")
  },
  {
    name: "about-us-our-team",
    path: "/about-us/our-team",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue")
  },
  {
    name: "our-neighborhoods",
    path: "/our-neighborhoods",
    meta: our_45neighborhoodskGsG_zAzBwUarH5q2bl2R_45ef_452S8LxVxUO2dEzgbL3kMeta || {},
    alias: ["/our-homes/model-homes/","/our-homes/quick-move-in-homes/"],
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue")
  },
  {
    name: "campaigns-slug",
    path: "/campaigns/:slug(.*)*",
    meta: _91_46_46_46slug_93NEoeBLU_45nVnHJhKDsK4oCvfeXJ_45agN3gu5QWI7UG7osMeta || {},
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue")
  },
  {
    name: "events-event",
    path: "/events/:event()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue")
  },
  {
    name: "knolls-hoa-information",
    path: "/knolls-hoa-information",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue")
  },
  {
    name: "lifestyle-brents-place",
    path: "/lifestyle/brents-place",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue")
  },
  {
    name: "marshallfire-slug",
    path: "/marshallfire/:slug(.*)*",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue")
  },
  {
    name: "rebuilding-altadena-ca",
    path: "/rebuilding-altadena-ca",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/rebuilding-altadena-ca.vue")
  },
  {
    name: "lifestyle-reviews",
    path: "/lifestyle/reviews",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue")
  },
  {
    name: "contact-us-our-locations",
    path: "/contact-us/our-locations",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue")
  },
  {
    name: "lifestyle-open-door-days",
    path: "/lifestyle/open-door-days",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/open-door-days.vue")
  },
  {
    name: "about-us-fun-part-journey",
    path: "/about-us/fun-part-journey",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue")
  },
  {
    name: "about-us-preferred-lender",
    path: "/about-us/preferred-lender",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue")
  },
  {
    name: "contact-us-ask-a-question",
    path: "/contact-us/ask-a-question",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue")
  },
  {
    name: "about-us-realtor-resources",
    path: "/about-us/realtor-resources",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue")
  },
  {
    name: "central-park-special-offer",
    path: "/central-park-special-offer",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue")
  },
  {
    name: "rebuilding-altadena-ca-map",
    path: "/rebuilding-altadena-ca-map",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/rebuilding-altadena-ca-map.vue")
  },
  {
    name: "lifestyle-sonders-lifestyle",
    path: "/lifestyle/sonders-lifestyle",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/sonders-lifestyle.vue")
  },
  {
    name: "sonders-lifestyle-thank-you",
    path: "/sonders-lifestyle-thank-you",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/sonders-lifestyle-thank-you.vue")
  },
  {
    name: "baseline-new-home-3k-payment",
    path: "/baseline-new-home-3k-payment",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/baseline-new-home-3k-payment.vue")
  },
  {
    name: "lifestyle-whats-lifefullness",
    path: "/lifestyle/whats-lifefullness",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue")
  },
  {
    name: "about-us-how-to-build-with-us",
    path: "/about-us/how-to-build-with-us",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/how-to-build-with-us.vue")
  },
  {
    name: "blog-category-category",
    path: "/blog/category/:category()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue")
  },
  {
    name: "contact-us-homeowner-resources",
    path: "/contact-us/homeowner-resources",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue")
  },
  {
    name: "about-us-energy-green-practices",
    path: "/about-us/energy-green-practices",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue")
  },
  {
    name: "contact-us-career-opportunities",
    path: "/contact-us/career-opportunities",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue")
  },
  {
    name: "lifestyle-reviews-testimonial",
    path: "/lifestyle/reviews/:testimonial()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue")
  },
  {
    name: "homes-location-community",
    path: "/homes/:location()/:community()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue")
  },
  {
    name: "our-homes-home-collections-easyhouse",
    path: "/our-homes/home-collections/easyhouse",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue")
  },
  {
    name: "lifestyle-experience-lower-maintenance",
    path: "/lifestyle/experience-lower-maintenance",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue")
  },
  {
    name: "our-homes-home-collections-wee-cottage",
    path: "/our-homes/home-collections/wee-cottage",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue")
  },
  {
    name: "about-us-homesafe-colorado-master-builder",
    path: "/about-us/homesafe-colorado-master-builder",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue")
  },
  {
    name: "our-homes-home-collections-limitededition",
    path: "/our-homes/home-collections/limitededition",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue")
  },
  {
    name: "lifestyle-reviews-category-category",
    path: "/lifestyle/reviews/category/:category()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue")
  },
  {
    name: "homes-location-community-qmi-home",
    path: "/homes/:location()/:community()/qmi/:home()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue")
  },
  {
    name: "homes-location-community-plans-plan",
    path: "/homes/:location()/:community()/plans/:plan()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue")
  },
  {
    name: "homes-location-community-models-model",
    path: "/homes/:location()/:community()/models/:model()",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue")
  },
  {
    name: "our-homes-home-collections-deed-restricted-wee-cottage",
    path: "/our-homes/home-collections/deed-restricted-wee-cottage",
    component: () => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/deed-restricted-wee-cottage.vue")
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/homes/boulder-co/peacock/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/what-to-expect/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/about-us/get-our-brochure/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/about-us/in-the-news/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/about-us/realtor-program/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/about-us/what-we-do/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/about-us/who-we-are/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/build-with-us/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/career-opportunities/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/career-opportunities/administrative-assistant-2/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/career-opportunities/director-of-warranty-services/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/career-opportunities/land-development-entitlements-coordinator/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/contact-us/ask-a-question/thank-you/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/contact-us/warranty-services/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/email-signup/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/get-updates/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/get-updates/thank-you/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/how-to-video-library/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/lifestyle/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/locations/lanterns-at-rock-creek/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/locations/silver-leaf/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/locations/wee-cottage-at-north-end-80238/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/locations/wee-cottage-at-rogers-farm/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/locations/west-edge-at-colliers-hill/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/login/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/lost-password/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/maintenance-items/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/marshall-fire-response/thank-you-loi/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/my-favorites/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/neighborhoods-map-test/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/organism-page/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/home-collections/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/home-collections/lanterns-series/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/home-collections/opportunities-series/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/photo-gallery/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/photo-gallery/gourmet-kitchens/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/photo-gallery/home-offices/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/photo-gallery/living-rooms/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/photo-gallery/outdoor-living-spaces/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/our-homes/photo-gallery/relaxing-master-suites/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/register/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/reset-password/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/resources-lower-maintenance/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/style-guide/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  },
  {
    name: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpMMeta?.name,
    path: "/warranty-service-request/",
    component: component_45stubKIfb75DorcpSNaL0hytbTrBcFCDZ2Db_45m81Zo7aQqpM
  }
]